module.exports = __webpack_public_path__ + "static/media/non_ulip.5e43fe9f.mp3";